/**
 * Shown on every calculator result AND in the PDF footer — exact text from CLAUDE.md.
 * Do not reword; if the wording needs to change, update CLAUDE.md first.
 */
export const DISCLAIMER_TEXT =
  "For education only. Figures are illustrative, based on assumed rates of return, and not " +
  "guaranteed. This is not personalised investment advice. Mutual fund investments are subject " +
  "to market risks.";

export function Disclaimer({ className = "" }) {
  return (
    <p className={`text-xs text-muted leading-relaxed border-t border-border pt-3 ${className}`}>
      {DISCLAIMER_TEXT}
    </p>
  );
}
